import * as angular from "angular";
import * as _ from "lodash"

angular
  .module('bringoz.admin.pricePlan')
  .filter('byAddress', byAddress);

function byAddress() {
  return function byAddressFilter(areas, searched) {

    if (_.isEmpty(searched)) {
      return areas;
    }

    const searchedIds = _.map(searched, (area) => {
      return area.areaId;
    });

    return _.filter(areas, (area) => {
      const index = searchedIds.indexOf(area.areaId);
      return !_.isEqual(index, -1);
    });
  }
}
